module.exports = __webpack_public_path__ + "img/Katarina_acc_06.3d3601c2.jpg";